import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './ImageFadeComponent.css';

const RANDOM_FACTOR = 0.5;

class ImageFadeComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      imgIndex: 0
    };

    this.timeout = null;
    this.switchImages = this.switchImages.bind(this);
  }

  componentDidMount() {
    this.scheduleNext();
  }

  scheduleNext() {
    const { durationMs, transitionMs, images } = this.props;

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    if (images.length > 1) {
      const imgDuration = Math.floor(
        durationMs * (1 + Math.random() * RANDOM_FACTOR)
      );
      this.timeout = setTimeout(this.switchImages, imgDuration + transitionMs);
    }
  }

  switchImages() {
    const images = this.props.images;
    if (images.length > 1) {
      this.setState({
        imgIndex: (this.state.imgIndex + 1) % images.length
      });
      this.scheduleNext();
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
  }

  render() {
    const { className, images, transitionMs, shadowClassName } = this.props;
    const { imgIndex } = this.state;
    const transition = `opacity ${transitionMs}ms linear`;

    const renderedImages = images.map(({ alt, url }, idx) => {
      const opacity = idx === imgIndex ? 1 : 0;
      return (
        <img key={idx} style={{ transition, opacity }} src={url} alt={alt} />
      );
    });

    return (
      <>
        <div className={'image-fade-component ' + (className || '')}>
          {renderedImages}
        </div>
        {shadowClassName && (
          <div
            className={'image-fade-component-shadow ' + shadowClassName}
            aria-hidden="true"
          >
            {renderedImages}
          </div>
        )}
      </>
    );
  }
}

ImageFadeComponent.propTypes = {
  className: PropTypes.string,
  durationMs: PropTypes.number,
  transitionMs: PropTypes.number,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string
      })
    })
  ).isRequired,
  shadowClassName: PropTypes.string
};

ImageFadeComponent.defaultProps = {
  durationMs: 2000,
  transitionMs: 300
};

export default ImageFadeComponent;
